import {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useLocation, useNavigate} from 'react-router-dom';

import {SpanIcon} from '@mazraeapp/react_icon_kit';
import DotsLoading from '../../../components/dotsLoading';
import CustomSearchBox from '../../../components/mazraeKit/customSearchBox';
import useGeAddressByTitleSearch from '../../../services/hookService/getLocationByTitleSearch/useGeAddressByTitleSearch';
import {RootState} from '../../../store/redux';
import {ISelected, removeState} from '../../../store/redux/searchingLocation';
import useDebounce from '../../../utilities/hooks/useDebounce/useDebounce';
import {useSafeNavigateBack} from '../myStore/pages/myStoreAdvertisement/useSafeNavigate';

const ChooseLocation = () => {
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const [inputValue, setInputValue] = useState('');
  const debouncedValue = useDebounce(inputValue, 2000);
  const [filterValue, setFilterValue] = useState<string>('');
  const {state}: {state: {from?: string}} = useLocation();
  const safeNavigateBack = useSafeNavigateBack(state?.from ?? '/home', {
    forceFallback: true,
  });

  const {address, isLoading} = useGeAddressByTitleSearch(filterValue);
  const {locational} = useSelector(
    (state: RootState) => state.searchingLocation,
  );

  const handleRemoveState = (guid?: string) => {
    dispatch(removeState(locational.filter(item => item.stateGuid !== guid)));
  };

  useEffect(() => {
    setFilterValue(inputValue);
  }, [debouncedValue]);

  return (
    <div className="flex flex-col w-full h-full">
      <div className="flex h-[56px] px-4 dropShadow w-full justify-between items-center text-md text-black">
        <div className="flex items-center">
          <i
            className="ml-3 text-xl font-bold icon-nameArrow---Right"
            onClick={() => safeNavigateBack()}
          />
          <span>انتخاب استان</span>
        </div>
        <i
          className="text-xl icon-nameClose-remove font-Bold"
          onClick={() => safeNavigateBack()}
        />
      </div>
      <hr className="mx-2 mt-0 text-gray-300" />
      <div className="px-4">
        <CustomSearchBox
          placeholder="جستجو در نام استان"
          type="text"
          value={inputValue}
          inputCustomClass="!pr-2"
          preIcon="icon-nameSearch"
          onChange={e => setInputValue(e.target.value)}
          {...{inputValue, setInputValue}}
        />
      </div>
      <div className="flex overflow-x-auto gap-1 px-3 mt-3">
        {locational
          .reduce((acc: Array<ISelected>, obj) => {
            if (!acc.some(accItem => accItem.stateGuid === obj.stateGuid)) {
              acc.push(obj);
            }
            return acc;
          }, [])
          .map(item => (
            <div
              key={item.stateGuid}
              className="flex gap-2 justify-between items-center px-3 py-2 whitespace-nowrap rounded-full bg-farm-shop-100 text-farm-shop-600"
            >
              <span className="text-sm">{item.stateTitle}</span>
              <i
                className="icon-nameClose-remove"
                onClick={() => handleRemoveState(item.stateGuid)}
              />
            </div>
          ))}
      </div>
      <div className="flex overflow-y-auto flex-col flex-1 px-4 dropShadow">
        {isLoading ? (
          <div className="flex justify-center items-center h-full">
            <DotsLoading />
          </div>
        ) : (
          address?.state?.map((item: ILocationByTitleSearch) => (
            <div
              key={item.guid || item.id}
              className="flex justify-between items-center py-4 w-full border-b"
              onClick={() =>
                navigate('/add-location', {
                  state: {
                    stateId: item.id,
                    stateName: item.name,
                    from: state?.from,
                  },
                })
              }
            >
              <span>{item.name}</span>
              <SpanIcon className="text-gray-500 icon-nameArrow---Left-2" />
            </div>
          ))
        )}
      </div>
      <div className="flex justify-between px-4 py-3 w-full rounded-t-lg shadow-dropShadow">
        <button
          onClick={() => safeNavigateBack()}
          className="flex h-[48px]  w-[45%]  items-center justify-center text-md font-Medium text-red-500 border-red-500 rounded-[8px] border-[1px] "
        >
          انصراف
        </button>
        <button
          disabled
          className="flex bg-gray-200 w-[45%] h-[48px]  items-center justify-center text-md font-Medium text-gray-500 rounded-[8px]"
        >
          تأیید
        </button>
      </div>
    </div>
  );
};

export default ChooseLocation;
